/**
 * Created by razial on 21.05.2026.
 */

if (cleverapps.styles.SingleProductOfferWindow && cleverapps.styles.SingleProductOfferWindow[Offers.TYPES.KINGSCUP]) {
    cleverapps.overrideStyles(cleverapps.styles.SingleProductOfferWindow[Offers.TYPES.KINGSCUP], {
        rewards: {
            worker: {
                rotation: -5,
                x: { align: "center", dx: 530 },
                y: { align: "center", dy: -350 }
            },
            energy: {
                rotation: 5,
                x: { align: "center", dx: -490 },
                y: { align: "center", dy: -350 }
            }
        }
    });
}
